import { getToken, getUser } from "../../Utils/Common";
import { getAPICall, postAPICall } from "../axiosMethodCalls";
import Moment from "moment";


export const getPurchaseReplacement = async (data) => {

    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "purchase_replacements/get",
            {
                requester: getUser(),
                token: getToken(),
                supplier_id: data.supplier_id,
                branch_id: data.branch_id,
                invoice_no: data.invoice_no,
                purchase_replacement_id: data.id ? data.id : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                page: data.page,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};


export const createPurchaseReplacement = async (data, items, files) => {
    let form_data = new FormData();
    form_data.append("requester", getUser());
    form_data.append("token", getToken());
    form_data.append("purchase_return_id", data.id);
    form_data.append("purchase_date", data.purchase_date);
    form_data.append("return_date", data.return_date);
    form_data.append("branch_id", data.branch_id);
    form_data.append("replacement_date", data.replacement_date);
    // form_data.append("purchase_return_no", data.purchase_return_no);
    form_data.append("supplier_id", data.supplier_id);
    form_data.append("status", data.status);
    form_data.append("grand_total", data.grand_total);
    form_data.append('receive_by_driver', data.receive_by_driver ? data.receive_by_driver : "");
    form_data.append('receive_by_bodega', data.receive_by_bodega ? data.receive_by_bodega : "");

    items.map((item) => {
        form_data.append(`purchase_return_item_id[]`,item.id);
        form_data.append(`item_id[]`,item.item_id);
        form_data.append(`qty[]`,item.qty);
        form_data.append(`unit[]`,item.unit);
        form_data.append(`price[]`,item.price);
        form_data.append(`amount[]`, item.amount);
        form_data.append(`item_remarks[]`, item.remarks ? item.remarks : "");
        // form_data.append(`serial_no[]`, item.serial_no ? item.serial_no : "");
        // form_data.append(`issue[]`, item.issue ? item.issue : "");
        // form_data.append(`reason[]`, item.reason ? item.reason : "");
    })

    files.map((file) => {
        form_data.append('attachments[]', file, file.name);
    });

    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "purchase_replacements/create", form_data
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updatePurchaseReplacement = async (data, items, files) => {
    let form_data = new FormData();
    form_data.append("requester", getUser());
    form_data.append("token", getToken());
    form_data.append("purchase_replacement_id", data.id);
    form_data.append("purchase_return_id", data.purchase_return_id);
    form_data.append("purchase_date", data.purchase_date);
    form_data.append("return_date", data.return_date);
    form_data.append("branch_id", data.branch_id);
    form_data.append("replacement_date", data.replacement_date);
    // form_data.append("purchase_return_no", data.purchase_return_no);
    form_data.append("supplier_id", data.supplier_id);
    form_data.append("status", data.status);
    form_data.append("grand_total", data.grand_total);
    form_data.append('receive_by_driver', data.receive_by_driver ? data.receive_by_driver : "");
    form_data.append('receive_by_bodega', data.receive_by_bodega ? data.receive_by_bodega : "");

    items.map((item) => {
        form_data.append(`purchase_replacement_item_id[]`,item.id);
        form_data.append(`purchase_return_item_id[]`,item.purchase_return_item_id);
        form_data.append(`item_id[]`,item.item_id);
        form_data.append(`qty[]`,item.qty);
        form_data.append(`unit[]`,item.unit);
        form_data.append(`price[]`,item.price);
        form_data.append(`amount[]`, item.amount);
        form_data.append(`item_remarks[]`, item.remarks ? item.remarks : "");
        // form_data.append(`serial_no[]`, item.serial_no ? item.serial_no : "");
        // form_data.append(`issue[]`, item.issue ? item.issue : "");
        // form_data.append(`reason[]`, item.reason ? item.reason : "");
    })

    files.map((file) => {
        form_data.append('attachments[]', file, file.name);
        form_data.append('attachment_ids[]', null);
    });
    data.prev_files.map((file) => {
        form_data.append('attachment_ids[]', file.id);
    });

    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "purchase_replacements/update", form_data
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};


export const deletePurchaseReplacement = async (id) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "purchase_replacements/delete",
            {
                requester: getUser(),
                token: getToken(),
                purchase_replacement_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};
